<template>
  <div v-if="items.length" class="table-totals">
    <span
      v-for="item in items"
      :key="item.label"
      class="table-totals__item"
      :class="{ 'table-totals__item--selection': item.selection }"
    >
      <span class="table-totals__label">{{ item.label }}</span>
      <span
        v-if="item.loading"
        class="custom-loader custom-loader--small"
      ></span>
      <strong v-else class="table-totals__value">{{ item.value }}</strong>
    </span>
  </div>
</template>

<script>
// Totali di una tabella mostrati fuori dalla tabella, nella riga della
// paginazione (dentro .pagination-wrapper, prima di .info-action):
// [{ label, value, loading, selection }]. selection: i valori delle righe
// selezionate, in azzurro per distinguerli dai totali.
// Vedi docs/SVILUPPO-UI.md (Tabelle).
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.table-totals {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: auto;
}

.table-totals__item {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  padding: 6px 14px;
  border-radius: var(--radius-pill);
  background: var(--color-total-bg);
}

.table-totals__label {
  color: var(--color-text-muted);
}

.table-totals__item--selection {
  background: rgba(var(--lisaweb-rgb), 0.14);

  .table-totals__label {
    color: var(--status-open);
  }
}

.table-totals__value {
  --font-family: var(--font-family-num);
  font-size: var(--font-size-md);
  color: var(--color-text);
}
</style>
